import '../scss/app_forms.scss';

require('./common.js');

require('../../public/app/JS/formHandle.js');
